import { render } from "./chevron-icon.vue?vue&type=template&id=6e45e5f2"
import script from "./chevron-icon.vue?vue&type=script&lang=js"
export * from "./chevron-icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__